import React from 'react';
import { CssBaseline, Grid } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import Preparing from '../components/Preparing';

class FreePaperPreview extends React.Component {
  render() {
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={2} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Preview & Modification</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <Preparing />
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default FreePaperPreview;
